import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-external-link-popup',
  templateUrl: './external-link-popup.component.html',
  styleUrls: ['./external-link-popup.component.scss'],
  standalone: false
})
export class ExternalLinkPopupComponent {
  @Input() color: string;
  @Output() validated = new EventEmitter<string>();
}
